import React, { useEffect, useState } from "react";
import { useInterviewContext } from "./InterviewContext";
import { Tab, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InterviewPageHeader from "./InterviewPageHeader";
import EducationAndWorkTab from "./Education&Work/EducationAndWorkTab";
import PersonalInformation from "./PersonalInformation/PersonalInformation";
import PersonalTechSkills from "./Personal&TechSkills/PersonalTechSkillsTab";
import GlobalClassification from "./GlobalClassification/GlobalClassificationTab";
import AvailabilityAndConditions from "./Availability&Conditions/AvailabilityAndConditionsTab";
import ModalInterviewHistory from "./InterviewOptions/ModalInterviewHistory";
import ModalDNASentSuccessfully from "./InterviewOptions/ModalDNASentSuccessfully";
import Documents from "./Documents/Documents";
import DOCOnlineSpinner from "../../containers/FullPageSpinner/FullPageSpinner";
import badgeErrors from "../../layout/others/exclamation_yellow_flat_icon.svg";
import newApplicationWarning from "../../layout/others/triangle-exclamation.svg";
import ModalAlertExistInterview from "./ModalAlertExistInterview";
import "./Interview.scss";
import "../styles/forms.scss";
import InterviewBadge from "./interviewBadge";
import InterviewTab from "./InterviewTab";
import { PreCandidateService } from "../../services/PreCandidate";
import { ApplicationDetailsList } from "./ReApplications/InterviewDetailsList";

import { TechRoleService } from "../../services/TechRoleService";
import { JobRoleDetailService } from "../../services/JobRoleDetailService";

const InterviewPage = ({ interviewId }) => {
  const {
    interview,
    saveInterview,
    errors,
    GetInterviewById,
    isTabsDisabled,
    setFormReady,
    shoModalSendDNA,
    setShowModalSendDNA,
    isLoading,
    LoadParameters,
    setEditMode,
    messageAlertExistInterview,
    showModalAlertExistInterview,
    setShowModalAlertExistInterview,
    tabActive,
    setTabActive,
    onchangeApplicationDetails,
    newApplicationAvailable,
    setInterview,
    documentLanguages,
    documentTypes,
    setUpdatesDocumentsGrid,
    updateDocumentsGrid
  } = useInterviewContext();
  const INTERVIEW = 1;

  const [managers, setManagers] = useState([]);
  const { t } = useTranslation();
  const [techAreaList, setTechAreaList] = useState([]);
  const [techRoleList, setTechRoleList] = useState([]);

  useEffect(() => {
    getTechAreas();
  }, []);

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setTechAreaList(data);
    });
  }
  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setTechRoleList(data);
    });
  }

  useEffect(() => {
    if (interview.techAreaId) {
      getTechRoles(interview.techAreaId);
    } else {
      TechRoleService.getAllTechRoles().then((data) => setTechRoleList(data));
    }
  }, [interview.techAreaId]);

  function onChange({ target }) {
    if (target.value)
      setInterview({
        ...interview,
        [target.name]: target.value
      });
    else {
      setInterview({
        ...interview,
        [target.name]: undefined
      });
    }
  }

  useEffect(() => {
    LoadParameters(interviewId);
    PreCandidateService.getPrecandidateManagers().then((data) =>
      setManagers(data)
    );
    if (interviewId) {
      GetInterviewById(interviewId);
      document.title = interview.personalInformation.fullName;
      setEditMode(true);
    } else {
      setFormReady(true);
      document.title = t("AtVitae - New Interview");
    }
  }, [t]);

  const TABS = {
    PersonalInformation: 0,
    EducationAndWork: 1,
    PersonalTechSkills: 2,
    AvailabilityAndConditions: 3,
    GlobalClassification: 4,
    Documents: 5,
    ApplicationDetails: 6
  };

  function onSelectTab(tabId) {
    setTabActive(tabId);
    saveInterview();
  }

  if (isLoading !== true) {
    return (
      <>
        <InterviewPageHeader />
        <div className="card inboard">
          <Tab.Container defaultActiveKey="personalInformation" id="interviews">
            <Nav variant="tabs" className="header-tabs">
              <InterviewTab
                isActive={tabActive === TABS.PersonalInformation}
                onSelect={() => onSelectTab(TABS.PersonalInformation)}
                isTabsDisabled={isTabsDisabled}
              >
                {t("Personal Information")}
                {(errors.birthDate ||
                  errors.fullName ||
                  errors.emailAddress ||
                  errors.maritalStatusId ||
                  errors.mobilePhoneNumber ||
                  errors.nationalityId) && (
                  <img src={badgeErrors} alt="error" />
                )}
              </InterviewTab>
              <InterviewTab
                isActive={tabActive === TABS.EducationAndWork}
                onSelect={() => onSelectTab(TABS.EducationAndWork)}
                isTabsDisabled={isTabsDisabled}
              >
                {t("Education & Work")}
                {(errors.projectsExperienceDetails ||
                  errors.professionalExperienceYearsId) && (
                  <img src={badgeErrors} alt="error" />
                )}
              </InterviewTab>

              <InterviewTab
                isActive={tabActive === TABS.PersonalTechSkills}
                onSelect={() => onSelectTab(TABS.PersonalTechSkills)}
                isTabsDisabled={isTabsDisabled}
              >
                {t("Personal & Tech Skills")}
                {(errors.technologies ||
                  errors.languageLevel ||
                  errors.otherLanguages) && (
                  <img src={badgeErrors} alt="error" />
                )}
              </InterviewTab>

              <InterviewTab
                isActive={tabActive === TABS.AvailabilityAndConditions}
                onSelect={() => onSelectTab(TABS.AvailabilityAndConditions)}
                isTabsDisabled={isTabsDisabled}
              >
                {t("Availability & Conditions")}
                {(errors.mobilityId ||
                  errors.fixedDate ||
                  errors.noticeId ||
                  errors.salaryExpected ||
                  errors.availabilityReasonId) && (
                  <img src={badgeErrors} alt="error" />
                )}
              </InterviewTab>

              <InterviewTab
                isActive={tabActive === TABS.GlobalClassification}
                onSelect={() => onSelectTab(TABS.GlobalClassification)}
                isTabsDisabled={isTabsDisabled}
              >
                {t("Global Classification")}
                {errors.rating && <img src={badgeErrors} alt="error" />}
              </InterviewTab>

              <InterviewTab
                isActive={tabActive === TABS.Documents}
                onSelect={() => onSelectTab(TABS.Documents)}
                isTabsDisabled={isTabsDisabled}
              >
                {t("Documents")}
              </InterviewTab>

              <InterviewTab
                isActive={tabActive === TABS.ApplicationDetails}
                onSelect={() => onSelectTab(TABS.ApplicationDetails)}
                isTabsDisabled={isTabsDisabled}
              >
                {t("Application Details")}
                {(errors.applicationDetailDate ||
                  errors.applicationDetailSource) && (
                  <img src={badgeErrors} alt="error" />
                )}
                {newApplicationAvailable && (
                  <img
                    src={newApplicationWarning}
                    alt={t("new application available")}
                    title={t("new application available")}
                  />
                )}
              </InterviewTab>
            </Nav>

            <Tab.Content>
              <div
                className={`card-body tab-pane fade ${
                  tabActive === TABS.PersonalInformation ? "active show" : ""
                }`}
                id="personalInformation"
                role="tabpanel"
                aria-labelledby="personalInformation"
              >
                {tabActive === TABS.PersonalInformation && (
                  <PersonalInformation />
                )}
              </div>
              <div
                className={`card-body tab-pane fade ${
                  tabActive === TABS.EducationAndWork ? "active show" : ""
                }`}
                role="tabpanel"
                aria-labelledby="educationWork"
              >
                {tabActive === TABS.EducationAndWork && <EducationAndWorkTab />}
              </div>
              <div
                className={`card-body tab-pane fade ${
                  tabActive === TABS.PersonalTechSkills ? "active show" : ""
                }`}
                role="tabpanel"
                aria-labelledby="techSkill"
              >
                {tabActive === TABS.PersonalTechSkills && (
                  <PersonalTechSkills />
                )}
              </div>
              <div
                className={`card-body tab-pane fade ${
                  tabActive === TABS.AvailabilityAndConditions
                    ? "active show"
                    : ""
                }`}
                role="tabpanel"
                aria-labelledby="availabilityAndConditions"
              >
                {tabActive === TABS.AvailabilityAndConditions && (
                  <AvailabilityAndConditions />
                )}
              </div>
              <div
                className={`card-body tab-pane fade ${
                  tabActive === TABS.GlobalClassification ? "active show" : ""
                }`}
                role="tabpanel"
                aria-labelledby="globalClassification"
              >
                {tabActive === TABS.GlobalClassification && (
                  <GlobalClassification />
                )}
              </div>
              <div
                className={`card-body tab-pane fade ${
                  tabActive === TABS.Documents ? "active show" : ""
                }`}
                role="tabpanel"
                aria-labelledby="documents"
              >
                {tabActive === TABS.Documents && (
                  <Documents
                    fromUrl="CreateOrEdit"
                    interview={interview}
                    disabled={false}
                    documentLanguages={documentLanguages}
                    documentTypes={documentTypes}
                    setUpdatesDocumentsGrid={setUpdatesDocumentsGrid}
                    updateDocumentsGrid={updateDocumentsGrid}
                  />
                )}
              </div>
              {interview.typeOfInterview === INTERVIEW && (
                <div
                  className={`card-body tab-pane fade ${
                    tabActive === TABS.ApplicationDetails ? "active show" : ""
                  }`}
                  role="tabpanel"
                  aria-labelledby="documents"
                >
                  <div className="col-8">
                    {tabActive === TABS.ApplicationDetails && (
                      <ApplicationDetailsList
                        list={interview.applicationDetails}
                        activeId={interview.applicationDetailId}
                        errors={errors}
                        managers={managers}
                        onChange={onchangeApplicationDetails}
                      />
                    )}
                  </div>
                </div>
              )}
            </Tab.Content>
          </Tab.Container>
        </div>
        <ModalInterviewHistory />
        <ModalDNASentSuccessfully
          showModal={shoModalSendDNA}
          setShowModal={setShowModalSendDNA}
        />{" "}
        <InterviewBadge text={interview.personalInformation?.fullName} />
        <ModalAlertExistInterview
          showModal={showModalAlertExistInterview}
          setShowModal={setShowModalAlertExistInterview}
          message={messageAlertExistInterview}
        />
      </>
    );
  } else {
    return <DOCOnlineSpinner text={t("Please wait while the page loads...")} />;
  }
};

export default InterviewPage;
